import React from 'react';

const LanguageIconSprite = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
      {/* Spanish flag */}
      <symbol id="flag-es" viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice">
        <rect width="3" height="2" fill="#AA151B"/>
        <rect y="0.5" width="3" height="1" fill="#F1BF00"/>
      </symbol>
      
      {/* England: St George's Cross (ratio 2:1) */}
      <symbol id="flag-en-england" viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice">
        <rect width="60" height="30" fill="#FFFFFF"/>
        <rect x="24" width="12" height="30" fill="#C8102E"/>
        <rect y="12" width="60" height="6" fill="#C8102E"/>
      </symbol>

      {/* United Kingdom: Union Flag (simplified, ratio 2:1) */}
      <symbol id="flag-en-gb" viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice">
        <rect width="60" height="30" fill="#012169"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4"/>
        <path d="M30,0 V30 M0,15 H60" stroke="#FFFFFF" strokeWidth="10"/>
        <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6"/>
      </symbol>
      
      {/* French flag */}
      <symbol id="flag-fr" viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice">
        <rect width="1" height="2" x="0" fill="#0055A4"/>
        <rect width="1" height="2" x="1" fill="#FFFFFF"/>
        <rect width="1" height="2" x="2" fill="#EF4135"/>
      </symbol>

      {/* German flag */}
      <symbol id="flag-de" viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice">
        <rect width="3" height="2" fill="#000000"/>
        <rect y="0.6667" width="3" height="0.6667" fill="#DD0000"/>
        <rect y="1.3333" width="3" height="0.6667" fill="#FFCE00"/>
      </symbol>
      
      {/* Portuguese flag */}
      <symbol id="flag-pt" viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice">
        <rect width="1.2" height="2" fill="#046A38"/>
        <rect x="1.2" width="1.8" height="2" fill="#DA020E"/>
        <circle cx="1.2" cy="1" r="0.3" fill="#FFD700"/>
        <circle cx="1.2" cy="1" r="0.2" fill="#DA020E"/>
      </symbol>
      
      {/* Neutral globe icon */}
      <symbol id="icon-globe" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        <path d="M3 12h18M12 3c3.6 3.8 3.6 13.2 0 18M8 3.8c2.3 2.5 2.3 13.9 0 16.4M16 3.8c-2.3 2.5-2.3 13.9 0 16.4" stroke="currentColor" strokeWidth="1.5" fill="none"/>
      </symbol>
    </svg>
  );
};

export default LanguageIconSprite;

